<template>
    <!-- 用户列表 -->
    <div style="padding: 20px;">
        <el-button v-if="$store.state.role.role.includes('worker.create')" type="primary" size="mini"
            @click="$refs.userAdd.show()">添加用户</el-button>
        <el-table :data="userList" :header-cell-style="{ 'text-align': 'center' }" :cell-style="{ padding: '0px' }"
            border stripe>
            <el-table-column v-for="(obj, key, index) in userKeys" :key="index" align="center" :prop="key"
                :label="obj.value" />
            <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                    <el-button v-if="$store.state.role.role.includes('worker.edit')" type="text" size="mini"
                        @click="$refs.userEdit.show(scope.row)">修改</el-button>
<!--  hcy: 删除按钮屏蔽。账号不能随便删除，关联数据太多。
					<el-button v-if="$store.state.role.role.includes('worker.delete')" type="text" size="mini"
                        @click="delList(scope.row)">删除</el-button> 
-->
                </template>
            </el-table-column>
        </el-table>
        <el-pagination style="text-align: center" background layout="prev, pager, next" @current-change="getUserList"
            :page-size="pageInfo.size" :current-page="pageInfo.page" :page-count="totalPages">
        </el-pagination>
        <!-- 用户添加弹框 -->
        <user-add-dialog ref="userAdd" @update="getUserList(pageInfo.page)" />
        <!-- 用户修改弹框 -->
        <user-edit-dialog ref="userEdit" @update="getUserList(pageInfo.page)" />
    </div>
</template>

<script>
    import * as api from "@/api/factory/user/list";
    import {
        userAddDialog,
        userEditDialog
    } from "./components";
    export default {
        components: {
            userAddDialog,
            userEditDialog,
        },
        data() {
            return {
                pageInfo: {
                    page: 1,
                    size: 18,
                },
                totalPages: 0,
                userList: [], //hongmj: 所有用户的列表?
                userKeys: {
                    name: {
                        value: "用户名"
                    },
                    cardNumber: {
                        value: "卡号"
                    },
                    role_change: {
                        value: "岗位"
                    },
                    shift: {
                        value: "班次"
                    },
                    phone: {
                        value: "手机号"
                    },
                    roleId_change: {
                        value: "角色"
                    },
                },

                roleId_list: [], //所有角色列表
            };
        },
        methods: {
            // 获取用户分页列表
            getUserList(val) {
                this.pageInfo.page = val;
                api.changePage(this.pageInfo).then((res) => {
                    this.userList = this.formatUserList(res.data.list);
                    this.totalPages = res.data.pages;
                });
            },
            // 格式化用户列表
            formatUserList(res) {
                const roles = this.$enum.roleArr;
                res.forEach((user) => {
                    // console.log("user=", user);

                    //1. 获取岗位信息
                    const enumArr = this.utils.formatEnum(user.role);
                    var enumName = "";
                    enumArr.forEach((item) => {
                        if ("管理员/厂长" == `${roles[item]}`) { //251015 hcy: 管理员信息不显示。
                            return; // 用return代替continue
                        } else {
                            enumName += ` ${roles[item]}`;
                        }
                    });
                    user.role_change = enumName;
                    // console.log("after change,user=", user);

                    //2. 转换rouleId(角色Id)为 角色名。
                    for (let i = 0; i < this.roleId_list.length; i++) {
                        if (user.roleId == this.roleId_list[i].id) {
                            // console.log("匹配成功");
                            user.roleId_change = this.roleId_list[i].roleName;
                            break;
                        }
                    }
                });
                return res;
            },
            delList(row) {
                console.log(row);
                api.userDel({
                    workerId: row.workerId
                }).then((res) => {
                    console.log(res);
                    if (res.code == 200) {
                        this.getUserList(1);
                    }
                });
            },


            // 初始化角色列表
            initRoleList1() {
                api.getRole().then((res) => {
                    // console.log(res);
                    this.roleId_list = res.data;
                    // console.log(this.roleId_list);

                    //解决bug：角色列有时候不显示，一定要获取角色列表成功后，再去初始化整个页面。
                    this.getUserList(1);
                });
            },
        },
        created() {
            this.initRoleList1(); //初始化角色列表
            // console.log("this.roleId_list=", this.roleId_list); //hongmj:好像必须延迟打印下，角色列才能显示。
        },
        watch: {
            $route() {
                this.getUserList(1);
            },
        },
    };
</script>

<style lang="scss" scoped>
    .el-tag {
        font-size: 15px;
    }
</style>